<template>
  <div class="stats-section">
    <div class="container">
      <StatsHeader 
        title="我们为客户提供"
        subtitle="专业的解决方案，全方位提升业务效率"
      />
      
      <div class="stats-grid">
        <div class="stat-card">
          <div class="stat-icon">
            <i class="fas fa-check-circle"></i>
          </div>
          <div class="stat-number">一站式业务接入</div>
          <div class="stat-label">运维，部署，监控效率翻四倍</div>
        </div>
        <div class="stat-card">
          <div class="stat-icon">
            <i class="fas fa-shield-virus"></i>
          </div>
          <div class="stat-number">一站式事中风险监控</div>
          <div class="stat-label">
            在所有部署环节具备事前风险控制和质量控制能力
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon">
            <i class="fas fa-database"></i>
          </div>
          <div class="stat-number">一站式数据平台</div>
          <div class="stat-label">高品质的数据中台，一个平台获得全部数据</div>
        </div>
        <div class="stat-card">
          <div class="stat-icon">
            <i class="fas fa-lock"></i>
          </div>
          <div class="stat-number">完备的安全体系</div>
          <div class="stat-label">多重安全措施保障您的数据安全</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import StatsHeader from './StatsHeader.vue'
</script>

<style scoped>
.stats-section {
  padding: 80px 0px 0px 0px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.stats-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}

@media (min-width: 768px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .stats-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.stat-card {
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 32px 24px;
  text-align: center;
  transition: all 0.3s ease;
  border: 1px solid #f3f4f6;
}

.stat-card:hover {
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  transform: translateY(-5px);
}

.stat-icon {
  width: 64px;
  height: 64px;
  background-color: #eff6ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  color: var(--primary-color);
  font-size: 24px;
  transition: background-color 0.3s ease;
}

.stat-icon i {
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-card:hover .stat-icon {
  background-color: #dbeafe;
}

.stat-number {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 8px;
  line-height: 1.3;
}

.stat-label {
  font-size: 14px;
  color: var(--text-color-gray);
  line-height: 1.5;
}
</style>